import createWebSocketPlugin from './ws';
import store from './store'
import urls from '../const'

const mutations = {
  setOrder(state, payload) {
    state.order.order = payload.order;
    if (payload.order != null) {
      state.order.clientFullPrice = payload.clientFullPrice;
      state.order.clientPaid = payload.clientPaid;
      state.order.city = payload.city;
      state.order.region = payload.region;
      state.order.items = payload.items;
      state.order.allowDeliveryDatesAndIntervals = payload.allowDeliveryDatesAndIntervals;
      state.order.searchField = payload.searchField;
    }
  },
  setPendingOrders(state, payload) {
    state.order.pending = payload.pending;
  },
  setClientPaid(state, payload) {
    state.order.clientFullPrice = payload.clientFullPrice;
    state.order.clientPaid = payload.clientPaid;
  },
  reconnectWS() {
    // todo небольшой костыль для того что бы можно было перезагружать сокет без перезагрузки страницы,
    //  регистрируюя новый плагин на горячую, старый плагин остается висеть в памяти но он уже не будет работать.
    const WS = new WebSocket(urls.socketURL);
    let plugin = createWebSocketPlugin(WS);
    plugin(store);
  },
  setWSConnectState(state, payload) {
    state.wsConnectState.connect = payload.connect;
    state.wsConnectState.error = payload.error;
    state.wsConnectState.ws = payload.ws;
  },
  setUser(state, payload) {
    state.user = payload.user;
  },
  setUsers(state, payload) {
    state.users = payload.users;
  },
  setLogs(state, payload) {
    state.logs = payload.logs;
  },
  setError(state, payload) {
    state.errors[payload.errorMethod] = {
      type: payload.errorMethod,
      title: payload.title,
      error: payload.error,
      show: payload.show,
    }
  },
  setMessage(state, payload) {
    state.messages[payload.msgMethod] = {
      type: payload.msgMethod,
      title: payload.title,
      msg: payload.msg,
      show: payload.show,
      event: payload.data,
    }
  }
};

export default mutations;



// WEBPACK FOOTER //
// ./src/store/mutations.js